export * from './academic/academic.component';
export * from './curriculum/curriculum.component';
export * from './acfeechart/acfeechart.component'
export * from './accmaster/accmaster.component'
export * from './assessment/assessment.component'